/**
 * Privacy Policy — plain-text placeholder. Edit the JSX to match your
 * legal team's approved language, or wire it up to a CMS content block
 * later.
 */
import { Link } from 'react-router-dom';

export default function PrivacyPolicy() {
  return (
    <div className="max-w-3xl mx-auto p-6 md:p-10 text-slate-800" data-testid="privacy-policy-page">
      <p className="text-xs text-slate-400 mb-2"><Link to="/" className="underline">← Home</Link></p>
      <h1 className="text-3xl font-bold text-slate-900">Privacy Policy</h1>
      <p className="text-xs text-slate-500 mt-1">Last updated: {new Date().toISOString().split('T')[0]}</p>

      <div className="prose prose-slate max-w-none mt-6 text-sm leading-relaxed space-y-4">
        <p>Your privacy matters to us. This policy explains what personal data we collect when you use our services (the "Service"), why we collect it, how we use it, and the choices you have.</p>

        <h2 className="text-lg font-semibold mt-6">1. What we collect</h2>
        <ul className="list-disc pl-5 space-y-1">
          <li><strong>Account data</strong> — email, name, phone number (optional), and password hash. Collected when you register or your organisation invites you.</li>
          <li><strong>Order / customer data</strong> — for shop, bookshop or event modules: delivery address, phone, payment method reference (we never store card numbers).</li>
          <li><strong>Usage data</strong> — anonymous session IDs, path visited, referrer, and coarse pseudo-anonymised IP / user-agent hashes to help us understand what parts of the Service are used.</li>
          <li><strong>Content you upload</strong> — images, PDFs, audio and video files you upload as part of your organisation's content library.</li>
        </ul>

        <h2 className="text-lg font-semibold mt-6">2. How we use it</h2>
        <ul className="list-disc pl-5 space-y-1">
          <li>To provide the Service (account access, orders, digital library, live streaming, transcription, etc.).</li>
          <li>To send transactional communications (order confirmation, password reset, invitation).</li>
          <li>To improve the Service and diagnose issues (aggregated analytics).</li>
        </ul>

        <h2 className="text-lg font-semibold mt-6">3. Sharing</h2>
        <p>We do <strong>not</strong> sell your personal data. We share data only with the sub-processors we need to run the Service (payment providers such as Stripe / PayPal, email delivery, cloud hosting). Each of them has their own privacy commitments.</p>

        <h2 className="text-lg font-semibold mt-6">4. Retention</h2>
        <p>We keep personal data for as long as you have an account with us and, after account closure, for the period required by law (typically 6 years for financial records).</p>

        <h2 className="text-lg font-semibold mt-6">5. Your rights</h2>
        <p>You may request access to, correction, or deletion of your personal data at any time. Contact your organisation administrator, or write to us at the email address published by your organisation.</p>

        <h2 className="text-lg font-semibold mt-6">6. Cookies</h2>
        <p>See our <Link to="/cookies" className="underline">Cookie Policy</Link> for details of the specific cookies and browser storage keys we set.</p>

        <h2 className="text-lg font-semibold mt-6">7. Changes</h2>
        <p>We may update this policy from time to time. When we do, we will notify signed-in users via the in-app consent banner.</p>

        <p className="text-xs text-slate-500 mt-8 border-t pt-4">This template is provided for convenience and does not constitute legal advice. Please review with your legal counsel before publishing.</p>
      </div>
    </div>
  );
}
